<template>
  <section ref="root" class="evento-lux">

    <!-- 🌸 FLOWERS -->
    <img src="@/assets/f.png" class="flor flor-1" alt="" />
    <img src="@/assets/f.png" class="flor flor-2" alt="" />

    <!-- 🌿 BRANCHES -->
    <img src="@/assets/ramas.png" class="rama rama-izq" alt="" />

    <!-- 🦋 BUTTERFLIES -->
    <img src="@/assets/mariposas.png" class="mariposa mariposa-1" alt="" />
    <img src="@/assets/mariposas.png" class="mariposa mariposa-2" alt="" />

    <!-- ===== CARD: RECEPTION & CEREMONY ===== -->
    <article ref="card1" class="card">
      <img class="icono" src="@/assets/10.avif" alt="" />
      <h3 class="titulo-script">Ceremony</h3>
      <p class="hora">5:00 PM</p>
      <p class="lugar">Desert Diamond</p>
      <p class="direccion">7421 W Indian School Rd.<br>Phoenix Arizona. </p>  

      
      <a
        class="btn-rosa"
        href="https://maps.app.goo.gl/kocBbDGiUtShn5tg8"
        target="_blank"
      >
        How to get there?
        <span class="sheen"></span>
      </a><br><br>
       <!-- SAME PLACE NOTICE -->
      <div class="mismo-lugar-aviso">
        <div class="linea-adorno"></div><br><br>
        <p>The ceremony and reception will be at the same location</p>
        <div class="linea-adorno"></div>
      </div>

    </article>

  </section>

  <div class="lux-escena-final">
    <div class="lux-degradado"></div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'TuComponente',

  setup() {
    const root = ref(null)
    const card1 = ref(null)
    const card2 = ref(null)
    const fotoLugar = ref(null)

    onMounted(() => {
      const $ = gsap.utils.selector(root.value)

      const flores = ['.flor-1', '.flor-2'].flatMap($)
      const ramas = ['.rama-izq'].flatMap($)
      const mariposas = ['.mariposa-1', '.mariposa-2'].flatMap($)

      // Seleccionamos los elementos de la tarjeta junto con el aviso del mismo lugar
      const texto1 = gsap.utils.selector(card1.value)([
        '.icono',
        '.titulo-script',
        '.hora',
        '.lugar',
        '.direccion',
        '.mismo-lugar-aviso',
        '.btn-rosa'
      ])

      const texto2 = gsap.utils.selector(card2.value)([
        '.icono',
        '.titulo-script',
        '.hora',
        '.lugar',
        '.direccion',
        '.btn-rosa'
      ])

      if (fotoLugar.value) {
        gsap.set(fotoLugar.value, {
          autoAlpha: 0,
          scale: 0.7,
          rotation: -8,
          y: 30
        })
      }

      gsap.set([...flores, ...texto1, ...texto2], { autoAlpha: 0, y: 28 })
      gsap.set(mariposas, { autoAlpha: 0, scale: 0.6, y: 40 })
      gsap.set(ramas, { autoAlpha: 0, scaleY: 0, transformOrigin: 'top center' })

      const io = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return

        const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

        tl.to(ramas, { autoAlpha: 1, scaleY: 1, duration: 0.9 })
          .to(flores, { autoAlpha: 1, y: 0, stagger: 0.12 }, '-=0.6')
          .to(mariposas, { autoAlpha: 1, y: 0, scale: 1, stagger: 0.12 }, '-=0.5')
          
          // Animación secuencial de la tarjeta con el aviso integrado
          .to(texto1, { autoAlpha: 1, y: 0, stagger: 0.08, duration: 0.6 }, '-=0.4')
          
          .to(texto2, { autoAlpha: 1, y: 0, stagger: 0.08, duration: 0.6 }, '-=0.2')

        io.disconnect()
      }, { threshold: 0.2 })

      io.observe(root.value)
    })

    return { root, card1, card2, fotoLugar }
  }
}
</script>

<style scoped>
.evento-lux{
  position: relative;
  overflow: visible;
  padding: 28px 18px 64px;
  display: grid;
  place-items: center;
  gap: 40px;
}

/* ===== TARJETA ===== */
.card{
  width: min(440px, 92vw);
  background: transparent;
  box-shadow: none;
  border: none !important;
  outline: none;
  padding: 24px 20px 28px;
  text-align: center;
  position: relative;
  z-index: 0;
}

.icono{
  width: 52px;
  margin: 0 auto 10px;
  opacity: .92;
}

.titulo-script{
  font-family: 'britishgruesa', cursive;
  font-size: 56px;
  color:rgb(42, 41, 42);
  margin: 4px 0 8px;
}

.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
}

.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  letter-spacing: .14em;
}

.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  font-size: 16px;
  font-weight: 600;
  color: var(--gris);
  margin-bottom: 12px;
}

/* ===== AVISO MISMO LUGAR ===== */
.mismo-lugar-aviso {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 12px 0 20px 0;
}

.mismo-lugar-aviso p {
  font-family: "Playfair Display", serif;
  font-size: 18px;
  font-style: italic;
  color: #4f6356;
  letter-spacing: 0.05em;
  margin: 0;
}

.linea-adorno {
  flex-grow: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(124, 145, 131, 0.4), transparent);
  max-width: 50px;
}

/* ===== BOTÓN ===== */
.btn-rosa{
  position: relative;
  display: inline-block;
  padding: 11px 20px;
  border-radius: 14px;
  background: #7c9183;
  color: #fff;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  box-shadow: 0 8px 16px rgba(0,0,0,.12);
  overflow: hidden;
}

.btn-rosa .sheen{
  position: absolute;
  top: -30%;
  left: -30%;
  width: 60%;
  height: 160%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
  transform: rotate(20deg);
  opacity: 0;
}

/* ===== ESCENA FINAL ===== */
.lux-escena-final{
  width: 100%;
  margin-top: 8px;
}

/* 🌸 FLORES */
.flor{
  position: absolute;
  width: 120px;
  z-index: 2;
  pointer-events: none;
}
.flor-1{ top: 630px; left: -30px; }
.flor-2{ top: -40px; right: -30px; }

/* 🌿 RAMAS */
.rama{
  position: absolute;
  top: -10px;
  right: -40px;
  width: 100px;
  z-index: 1;
  pointer-events: none;
}

/* 🦋 MARIPOSAS */
.mariposa{
  position: absolute;
  width: 82px;
  z-index: 4;
  pointer-events: none;
}
.mariposa-1{ top: -30px; right: 92%; }
.mariposa-2{ bottom: 140px; right: 90%; }
</style>